<template>
  <eg-b-sidebar
    id="rubric-library-sidebar"
    ref="sidebarRef"
    width="680px"
    right
    shadow
    lazy
    no-header
    backdrop
    backdrop-variant="transparent"
    sidebar-class="bg-white"
    :class="['rubric-sidebar', { 'with-buttons': !autoCommit }]"
    @shown="onShown"
  >
    <template #default="{ hide }">
      <div
        class="rubric-sidebar-header d-flex align-items-center justify-content-between"
      >
        <div class="heading-s color-text-neutral-on-white">
          {{ $t("rubrics.title") }}
        </div>

        <div class="d-flex align-items-center flex-gap-1">
          <create-rubric-dropdown v-if="showAddNew" />
          <tour-compass-button
            context="sidebar_rubricLibrary"
            trigger-event="onboarding:opened:rubricLibrary"
          />
          <eg-button type="ordinary" icon="close" @click="hide"> </eg-button>
        </div>
      </div>

      <div class="divider"></div>

      <RubricLibraryView
        ref="rubricLibraryView"
        :value="autoCommit ? value : rubric"
        :show-add-new="showAddNew"
        filters-size="medium"
        @selectRubric="selectRubric"
      />
      <div v-if="!autoCommit" class="d-flex p-3 justify-content-end">
        <eg-b-button variant="outline-info" @click="hide">{{
          $t("common.cancel")
        }}</eg-b-button>
        <eg-b-button
          class="ml-3"
          variant="info"
          @click="
            hide();
            onSave();
          "
        >
          {{ $t("rubrics.saveChanges") }}
        </eg-b-button>
      </div>
    </template>
  </eg-b-sidebar>
</template>

<script>
import RubricLibraryView from "@/components/rubrics/rubric_library_view.vue";
import EgButton from "@/components/global/eg/buttons/eg_button.vue";
import TourCompassButton from "@/components/global/tour_compass_button.vue";
export default {
  name: "RubricLibrarySidebar",

  components: {
    RubricLibraryView,
    EgButton,
    TourCompassButton,
    CreateRubricDropdown: () =>
      import("@/components/rubrics/components/create_rubric_dropdown.vue"),
  },

  props: {
    value: {
      type: Object,
      default: () => {},
    },
    showAddNew: Boolean,
    autoCommit: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      rubric: this.value,
    };
  },
  methods: {
    selectRubric(value) {
      if (this.autoCommit) {
        this.$emit("input", value);
        this.$refs.sidebarRef.hide();
      } else {
        this.rubric = value;
      }
    },
    onSave() {
      this.$emit("input", this.rubric);
    },

    onShown() {
      this.$eventBus.$emit("onboarding:opened:rubricLibrary");
    },
  },
};
</script>

<style lang="scss" scoped>
.divider {
  width: 100%;
  border-bottom: 1px solid var(--color-stroke-neutral-default);
}

.title-text {
  color: var(--Text-Body, #212529);
  font-size: 24px;
  font-weight: 500;
  line-height: 28px;
}

.rubric-sidebar {
  ::v-deep .tab-pane {
    padding: 0 24px;
    background-color: var(--color-surface-neutral-canvas);
  }
  .rubric-sidebar-header {
    padding: 16px 24px;
  }

  &::v-deep {
    .eg-tabs__nav {
      padding: 0 1.5rem;
    }

    .tab-content {
      overflow: hidden;
      height: calc(100vh - 120px);
    }
    .tab-pane.active {
      min-height: calc(100vh - 120px);
      height: max-content;
    }

    .name-row {
      max-width: 210px;
      overflow: hidden;
    }
    .eg-tabs__container .nav-tabs {
      padding-top: 0.75rem;
    }
    .empty-state {
      height: calc(100vh - 190px);
    }
  }
}

.with-buttons {
  &::v-deep :not(.b-sidebar-right) {
    .tab-content {
      height: calc(100vh - 190px - var(--maintenance-height));
    }

    .tab-pane.active {
      height: calc(100vh - 280px - var(--maintenance-height));
    }
  }
}
</style>
